import { Alert, Link, Text } from '@nimbus-ds/components';
import { Trans } from 'react-i18next';
import { useNavegate } from 'App/hooks';
import { PROMOTIONS_ROUTES } from 'domains/Marketing/Promotions/promotionsRoutes';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

interface PercentageOffDiscountAlertProps {
  isGeneral?: boolean;
}

function PercentageOffDiscountAlert({
  isGeneral = false,
}: PercentageOffDiscountAlertProps): JSX.Element {
  const t = useTranslationPayments('paymentProvider.settings');
  const { goTo } = useNavegate();

  const handleGoToPromotions = () => {
    goTo(PROMOTIONS_ROUTES.promotionsList);
  };

  const translationKey = isGeneral
    ? 'hasPercentageOffDiscountGeneral'
    : 'hasPercentageOffDiscount';

  return (
    <Alert appearance="primary">
      <Text>
        <Trans
          t={t}
          i18nKey={translationKey}
          components={{
            promotionsLink: (
              <Link
                as="button"
                textDecoration="underline"
                onClick={handleGoToPromotions}
              >
                {}
              </Link>
            ),
          }}
        />
      </Text>
    </Alert>
  );
}

export default PercentageOffDiscountAlert;
